const addToDataLayer = objectToAdd => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(objectToAdd);
};

export default addToDataLayer;
